<div class="panel-group" role="tablist" aria-multiselectable="true">
  <div class="panel" id="panelFilter">
    <div class="panel-heading" role="tab" id="headingFilter">
      <h4 class="panel-title">
        <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordionFilter" href="#collapseFilter"
          aria-expanded="false" aria-controls="collapseFilter">
          <span class="material-icons">filter_alt</span> Filtros
        </a>
      </h4>
    </div>
    <div id="collapseFilter" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFilter"
      aria-expanded="false">
      <div class="panel-body">
        <div class="row">
          <div class="col-md-2">
            <mat-form-field>
              <mat-label>Ativo</mat-label>
              <mat-select [(ngModel)]="searchAtivo.searchTerm">
                <mat-option [value]="true">Ativo</mat-option>
                <mat-option [value]="false">Inativo</mat-option>
              </mat-select>              
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field>
              <mat-label>Filtrando por:</mat-label>
              <mat-select [(ngModel)]="search.field">
                <mat-option value="nome">Nome</mat-option>
                <mat-option value="grupo">Grupo</mat-option>
                <mat-option *ngIf="isKleinCode" value="tenant.nomeFantasia">Empresa (Tenant)</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-2">
            <mat-form-field>
              <mat-label>Tipo Filtro</mat-label>
              <mat-select [(ngModel)]="search.option">
                <mat-option *ngFor="let option of filterOptions" [value]="option.value">{{option.text}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-form-field>
              <mat-label>Pesquisar por</mat-label>
              <input matInput type="text" [(ngModel)]="search.searchTerm" (keyup.enter)="filter()" />
              <mat-error>Informe um termo válido.</mat-error>
            </mat-form-field>
          </div>          
        </div>
      </div>
      <div class="panel-footer" style="text-align: right">        
        <button mat-flat-button color="primary" (click)="filter()">
          <span>Filtrar</span>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="card main-content">  
  <div class="header">
    <h2>Usuários</h2>
  </div>
  <div class="body table-responsive">    
    <table datatable [dtOptions]="dtOptions" *ngIf="dtOptions" class="table table-bordered table-striped table-hover"
      style="width: 100%;">
      <thead>
        <tr>
          <th class="text-center">Nome</th>
          <th class="text-center">Sobrenome</th>
          <th class="text-center">Email</th>
          <th class="text-center">Usuário</th>
          <th class="text-center">Grupo Usuário</th>
          <th class="text-center">Status</th>
          <th class="text-center">Super Usuário</th>
          <th class="text-center" *ngIf="isKleinCode">Tenant</th>
          <th class="text-center" width="200"></th>
        </tr>
      </thead>
      <tbody *ngIf="usuarios?.length != 0">
        <tr *ngFor="let usuario of usuarios">
          <td>
            {{usuario.nome}}
          </td>
          <td>
            {{usuario.sobrenome}}
          </td>
          <td>
            {{usuario.email}}
          </td>
          <td>
            {{usuario.userNameTenant}}
          </td>
          <td>
            {{usuario.grupoUsuarioNome}}
          </td>
          <td class="text-center">
            <span [ngClass]="{'bg-red': !usuario.ativo, 'bg-green': usuario.ativo}" class="label">
              {{usuario.ativo ? 'Ativo' : 'Inativo'}}
            </span>
          </td>
          <td class="text-center">
            <span [ngClass]="{'bg-grey': !usuario.superUsuarioTenant, 'bg-green': usuario.superUsuarioTenant}"
              class="label">
              {{usuario.superUsuarioTenant ? 'Sim' : 'Não'}}
            </span>
          </td>
          <td *ngIf="isKleinCode">
            {{usuario.tenantNomeFantasia}}
          </td>
          <td class="text-center">
            <button *ngIf="!usuario.superUsuarioTenant && !isKleinCode" mat-icon-button type="button"
              (click)="definirSuperUsuario(usuario)" matTooltip="Definir Super Usuário">
              <mat-icon>check</mat-icon>
            </button>
            <button [disabled]="!isAllowed('Update')" mat-icon-button type="button" (click)="editPassword(usuario)"
              matTooltip="Alterar Senha">
              <mat-icon>vpn_key</mat-icon>
            </button>
            <button [disabled]="!isAllowed('Update')" mat-icon-button type="button" (click)="edit(usuario)"
              matTooltip="Editar">
              <mat-icon>edit</mat-icon>
            </button>
            <button [disabled]="!isAllowed('Delete')" mat-icon-button type="button" (click)="delete(usuario.id)"
              matTooltip="Excluir">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="fixed-action-btn">
    <button [disabled]="!isAllowed('Create')" mat-fab color="primary" (click)="create()" matTooltip="Adicionar (F9)"
      matTooltipPosition="above">
      <mat-icon>add</mat-icon>
    </button>
  </div>
</div>

<app-usuario-modal #usuarioModal (modalSave)="onResponse($event)"></app-usuario-modal>
